<template>
  <tag
    :title="title"
    class="products-count-tag"
  />
</template>

<script>
import { pluralize } from '@/utils/string-utils';
import Tag from '@kit/tag/tag.vue';

export default {
  name: 'products-count-tag',

  components: { Tag },

  props: {
    count: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    title() {
      return `${pluralize(this.count, ['товар', 'товара', 'товаров'])} из ${this.total}`;
    },
  },
};
</script>

<style lang="scss">
.products-count-tag {
  padding: 2px 4px;
  font-size: 10px;
  white-space: nowrap;
}

@include breakpoint("tablet") {
  .products-count-tag {
    padding: 4px 8px;
    font-size: 12px;
  }
}
</style>
